function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCvv({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 392.598 392.598",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M359.822,21.689H32.711c-6.012,0-10.925,4.848-10.925,10.925v204.671 c0,6.012,4.848,10.925,10.925,10.925h327.111c6.012,0,10.925-4.848,10.925-10.925V32.549 C370.747,26.602,365.834,21.689,359.822,21.689z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.572,
    y: 43.539,
    style: {
      fill: "#FFC10D"
    },
    width: 305.325,
    height: 182.82
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M80.614,320.549c-3.426-4.978-10.214-6.206-15.127-2.78l-11.83,8.145v-14.352 c0-6.012-4.848-10.925-10.925-10.925s-10.925,4.848-10.925,10.925v14.352l-11.83-8.145c-4.913-3.426-11.766-2.133-15.127,2.78 c-3.426,4.913-2.133,11.766,2.78,15.127l15.838,10.925L7.628,357.527c-4.978,3.426-6.206,10.214-2.78,15.127 c3.426,4.978,10.214,6.206,15.127,2.78l11.83-8.145v14.352c0,6.012,4.848,10.925,10.925,10.925s10.925-4.848,10.925-10.925v-14.352 l11.83,8.145c4.978,3.426,11.766,2.133,15.127-2.78c3.426-4.913,2.133-11.766-2.78-15.127l-15.838-10.925l15.838-10.925 C82.747,332.315,83.976,325.527,80.614,320.549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M193.034,320.549c-3.426-4.978-10.214-6.206-15.127-2.78l-11.83,8.145v-14.352 c0-6.012-4.848-10.925-10.925-10.925c-6.077,0-10.925,4.848-10.925,10.925v14.352l-11.83-8.145 c-4.913-3.426-11.766-2.133-15.127,2.78c-3.426,4.913-2.133,11.766,2.78,15.127l15.838,10.925l-15.838,10.925 c-4.913,3.426-6.206,10.214-2.78,15.127c3.426,4.978,10.214,6.206,15.127,2.78l11.83-8.145v14.352 c0,6.012,4.848,10.925,10.925,10.925c6.077,0,10.925-4.848,10.925-10.925v-14.352l11.83,8.145 c4.913,3.426,11.766,2.133,15.127-2.78c3.426-4.913,2.133-11.766-2.78-15.127l-15.838-10.925l15.838-10.925 C195.168,332.315,196.396,325.527,193.034,320.549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M288.323,355.459h-43.766c-6.012,0-10.925,4.848-10.925,10.925c0,6.012,4.848,10.925,10.925,10.925 h43.766c6.012,0,10.925-4.848,10.925-10.925C299.184,360.436,294.335,355.459,288.323,355.459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M381.673,355.459h-43.766c-6.012,0-10.925,4.848-10.925,10.925c0,6.012,4.848,10.925,10.925,10.925 h43.766c6.012,0,10.925-4.848,10.925-10.925C392.533,360.436,387.685,355.459,381.673,355.459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M359.822,0.032H32.711C14.675,0.032,0,14.707,0,32.743v204.606 c0,17.972,14.675,32.646,32.711,32.646h327.111c18.036,0,32.711-14.675,32.711-32.711V32.743 C392.533,14.707,377.859,0.032,359.822,0.032z M370.747,237.414c0,6.012-4.848,10.925-10.925,10.925H32.711 c-6.012,0-10.925-4.848-10.925-10.925V32.743c0-6.012,4.848-10.925,10.925-10.925h327.111c6.012,0,10.925,4.848,10.925,10.925 V237.414L370.747,237.414z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56ACE0"
    },
    d: "M101.366,76.962h-8.598c-6.012,0-10.925,4.848-10.925,10.925v8.598 c0,6.012,4.848,10.925,10.925,10.925h8.598c6.012,0,10.925-4.848,10.925-10.925v-8.598 C112.291,81.875,107.378,76.962,101.366,76.962z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M101.366,55.176h-8.598c-18.036,0-32.711,14.675-32.711,32.711v8.598 c0,18.036,14.675,32.711,32.711,32.711h8.598c18.036,0,32.711-14.675,32.711-32.711v-8.598 C134.077,69.786,119.402,55.176,101.366,55.176z M112.291,96.485c0,6.012-4.848,10.925-10.925,10.925h-8.598 c-6.012,0-10.925-4.848-10.925-10.925v-8.598c0-6.012,4.848-10.925,10.925-10.925h8.598c6.012,0,10.925,4.848,10.925,10.925V96.485 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M91.022,174.772h-20.04c-6.012,0-10.925-4.848-10.925-10.925c0-6.077,4.848-10.925,10.925-10.925 h20.04c6.012,0,10.925,4.848,10.925,10.925C101.947,169.923,97.034,174.772,91.022,174.772z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M146.683,214.594H71.046c-6.012,0-10.925-4.848-10.925-10.925c0-6.012,4.848-10.925,10.925-10.925 h75.636c6.012,0,10.925,4.848,10.925,10.925C157.543,209.745,152.695,214.594,146.683,214.594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M146.683,174.772h-20.04c-6.012,0-10.925-4.848-10.925-10.925c0-6.077,4.848-10.925,10.925-10.925 h20.04c6.012,0,10.925,4.848,10.925,10.925C157.608,169.923,152.695,174.772,146.683,174.772z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M202.279,174.772h-20.04c-6.012,0-10.925-4.848-10.925-10.925c0-6.077,4.848-10.925,10.925-10.925 h20.04c6.012,0,10.925,4.848,10.925,10.925C213.204,169.923,208.291,174.772,202.279,174.772z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56ACE0"
    },
    d: "M296.404,163.459c2.004,4.461,3.103,9.438,3.103,14.675s-1.099,10.214-3.103,14.675 c7.887-0.259,14.222-6.723,14.222-14.675S304.291,163.717,296.404,163.459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56ACE0"
    },
    d: "M262.982,163.394c-8.145,0-14.675,6.594-14.675,14.675s6.594,14.675,14.675,14.675 c8.081,0,14.675-6.594,14.675-14.675C277.721,170.052,271.063,163.394,262.982,163.394z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M295.952,141.608c-5.689,0-11.313,1.487-16.356,4.008c-4.913-2.521-10.602-4.008-16.549-4.008 c-20.17,0-36.525,16.356-36.525,36.525s16.356,36.525,36.525,36.525c6.012,0,11.636-1.487,16.614-4.008 c0.646,0.453,1.293,0.84,2.069,1.164c4.461,1.939,9.244,2.844,14.222,2.844c20.17,0,36.525-16.356,36.525-36.525 C332.412,157.964,316.057,141.608,295.952,141.608z M296.404,192.808c2.004-4.461,3.103-9.438,3.103-14.675 c0-5.236-1.099-10.214-3.103-14.675c7.887,0.259,14.222,6.723,14.222,14.675C310.626,186.085,304.291,192.485,296.404,192.808z  M262.982,192.808c-8.145,0-14.675-6.594-14.675-14.675s6.594-14.675,14.675-14.675c8.081,0,14.675,6.594,14.675,14.675 C277.721,186.279,271.063,192.808,262.982,192.808z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvv);
export default __webpack_public_path__ + "static/media/cvv.a27e0fee49502205ea96ccea01f8a21d.svg";
export { ForwardRef as ReactComponent };